import React, { useEffect, useMemo, useState } from "react";
import Point from "../../interfaces/robot/rooms/point";
import K900_Vector from "../../images/K900_Vector.svg";
import K700_Vector from "../../images/K700_Vector.svg";
import RobotVersion from "../../interfaces/cleaning-map/robot-version";

interface KRobotSvgProps extends Point {
  robotRadius: number;
  disableAnimation?: boolean;
  model: RobotVersion
}

const KRobotSvgComponent: React.FC<KRobotSvgProps> = ({
  coordinateX,
  coordinateY,
  coordinateTheta,
  disableAnimation,
  robotRadius = 5,
  model
}) => {
  const [theta, setTheta] = useState(0);

  useEffect(() => {
    setTheta(
      (prevState) => prevState + (((((180 / Math.PI) * (coordinateTheta ?? 0) - prevState) % 360) + 540) % 360) - 180
    );
  }, [coordinateTheta]);

  const scalingFactor = 2.9;
  const coordinateShift = 1.45; // scalingFactor / 2

  return (
    <g
      transform={`translate(${coordinateX}, ${coordinateY}) rotate(${-theta + 90})`}
      style={{ transition: disableAnimation ? "none" : "all 1s ease-out" }}
    >
      <image
        href={model === RobotVersion.K900 ? K900_Vector : K700_Vector}
        x={-robotRadius * coordinateShift}
        y={-robotRadius * coordinateShift}
        width={robotRadius * scalingFactor}
        height={robotRadius * scalingFactor}
        preserveAspectRatio="xMidYMid meet"
      />
    </g>
  );
};

const KRobotSvg = React.memo(
  KRobotSvgComponent,
  (prevProps, nextProps) =>
    prevProps.coordinateX === nextProps.coordinateX &&
    prevProps.coordinateY === nextProps.coordinateY &&
    prevProps.coordinateTheta === nextProps.coordinateTheta
);

export default KRobotSvg;
